/*
  Sticky productbalk — wanneer verschijnt hij.

  22-09-2026: het doelwit werd .product-details__buy-buttons (aantalveld +
  koopknop) in plaats van de hele infokolom, en de prijsvoorwaarde ging eruit.

  01-10-2026: herschreven, niet meer de gecompileerde Endeavour-code.

  WAS

  Een IntersectionObserver die de balk toonde zodra het koopblok niet in beeld
  was. "Niet in beeld" betekent ook: nog niet in beeld, omdat het onder de
  vouw staat. Op een laptopscherm (hoogte rond 770px) staat het koopblok bij
  het openen van de pagina onder de vouw, dus verscheen de balk meteen - met
  de koopknop van de pagina zelf nog maar een stukje lager. Er stonden dan
  twee koopknoppen tegelijk, en de balk bleef staan tot je voorbij het
  koopblok was en weer terug.

  IS

  Desktop (vanaf 1024px): de balk verschijnt pas als je voorbij het koopblok
  bent gescrold, dus als de onderkant ervan boven de onderkant van de
  sticky header ligt. Scrol je terug tot het koopblok weer onder de header
  vandaan komt, dan gaat de balk weg. Onder de vouw = geen balk.

  Mobiel (tot 1024px): ongewijzigd. De balk komt van onderen en staat er
  zodra het koopblok niet in beeld is, ook als dat komt doordat het nog onder
  de vouw staat. Op mobiel is dat de bedoeling: daar staat de koopknop bij
  het openen bijna altijd onder de vouw.

  De onderkant van de header komt uit --c4s-header-bottom, die
  snippets/c4s-mega-menu-runtime.liquid op <html> zet. Gemeten op scroll en
  resize, gebundeld per animatieframe.

  De terugval op .product-details staat er voor templates waar het koopblok
  anders heet (de new-pdp-variant).

  Klik op de koopknop in de balk = submit van het formulier op de pagina,
  zoals voorheen: de variant en het aantal komen dan uit hetzelfde formulier.
*/
var c = class extends HTMLElement {
  constructor() {
    super();
    var balk = this;
    var formulier = null;
    var doel = null;
    var knop = null;
    var desktop = window.matchMedia('(min-width: 1024px)');
    var actief = null;
    var gepland = false;

    var verstuur = function (e) {
      e.preventDefault();
      if (formulier) formulier.requestSubmit();
    };

    var zet = function (toon) {
      if (toon === actief) return;
      actief = toon;
      if (toon) {
        balk.classList.add('js-active');
        if (knop) knop.addEventListener('click', verstuur);
      } else {
        balk.classList.remove('js-active');
        if (knop) knop.removeEventListener('click', verstuur);
      }
    };

    var headerOnderkant = function () {
      var waarde = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--c4s-header-bottom'));
      return isNaN(waarde) ? 0 : waarde;
    };

    var meet = function () {
      gepland = false;
      if (!doel) return;
      var r = doel.getBoundingClientRect();
      if (desktop.matches) {
        zet(r.bottom < headerOnderkant());
      } else {
        var hoogte = window.innerHeight || document.documentElement.clientHeight;
        zet(r.bottom <= 0 || r.top >= hoogte);
      }
    };

    var plan = function () {
      if (gepland) return;
      gepland = true;
      window.requestAnimationFrame(meet);
    };

    /* De balk staat in de DOM vóór het koopblok. Draait dit script voordat
       de rest van de pagina er is, dan wordt er pas bij DOMContentLoaded
       gezocht. */
    var start = function () {
      formulier = document.querySelector('.main-product product-form form');
      doel = document.querySelector('.product-details__buy-buttons') || document.querySelector('.product-details');
      knop = balk.querySelector('button[type="submit"]');
      if (!doel) return;
      window.addEventListener('scroll', plan, { passive: true });
      window.addEventListener('resize', plan, { passive: true });
      window.addEventListener('load', plan);
      if (desktop.addEventListener) desktop.addEventListener('change', plan);
      meet();
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start);
    } else {
      start();
    }
  }
};
customElements.define('product-bar', c);
